










































import { defineComponent } from '@nuxtjs/composition-api';
import { useAnimationControl } from '~/composables/useAnimationControl';

export default defineComponent({
  name: 'AnimationControlButton',
  setup() {
    const { isPaused, toggleAnimations } = useAnimationControl();

    return {
      isPaused,
      toggleAnimations,
    };
  },
});
